import { showNotification } from "@mantine/notifications";
import { getEntityLabel } from "../data/mcaEntities";
import { resolveEntityPath } from "./resolveEntityPath";
import { getEntityTabLabel } from "./tabNavigation";

export function openEntityEditTab(
  tabNav,
  { entity, id, label, userRole, currentPathname, pathname: pathnameOverride }
) {
  if (entity === "approval") {
    if (!id) return;
    const pathname = `/management/mcaProcess/${id}`;
    if (tabNav.enabled) {
      tabNav.open({ pathname, label: label ?? "Approval Process" });
    } else {
      window.open(pathname, "_blank");
    }
    return;
  }

  if (entity === "quiz") {
    const base =
      resolveEntityPath("quiz", userRole, currentPathname) ??
      (currentPathname?.startsWith("/management")
        ? "/management/quiz"
        : "/operation/quiz");
    const pathname = `${base}/${id}/edit`;
    if (tabNav.enabled) {
      tabNav.open({ pathname, label: label ?? "Quiz" });
    } else {
      window.open(pathname, "_blank");
    }
    return;
  }

  const pathname =
    pathnameOverride || resolveEntityPath(entity, userRole, currentPathname);
  if (!pathname) {
    if (!id) return;
    showNotification({
      title: "Cannot open entity",
      message: `No detail page configured for ${getEntityLabel(entity)}.`,
      color: "red",
    });
    return;
  }
  if (!id) return;

  const tabLabel = label ?? getEntityTabLabel(null, id, entity);
  if (tabNav.enabled) {
    tabNav.openDetail({ pathname, id, mode: "edit", label: tabLabel });
  } else {
    window.open(`${pathname}?id=${id}&mode=edit`, "_blank");
  }
}
